import './lib/foundation-explicit-pieces';


$(document).foundation();

$(document).ready(function(){
	var hero = $('#hero .slide');

	if (hero.length > 1) {
		var swiper = new Swiper('#hero', {
			loop: true,
			effect: 'fade',
			pagination: {
				el: '.hero-pagination',
				clickable: true
			},
			autoplay: {
				delay: 5000,
				pauseOnMouseEnter: true
			},
			breakpoints: {
				1024: {
					slidesPerView: 3,
                    slidesPerGroup: 3
				}
			}
		});

		$(".hero-button-pause").on('click', function(){
			if ($(this).hasClass('active')) {
				swiper.autoplay.start();
			} else {
				swiper.autoplay.stop();
			}
			$(this).toggleClass('active');
		});
	}
});